import { observer } from 'src/utils/mobx-react';
import {
    ItemButton,
    ItemWrapper,
    VerticalMoveIconWrapper,
} from 'src/components/SportPopup/SportCompetitions/SportCompetitions.style';
import React from 'react';
import styled from '@emotion/styled';
import { CompetitionType, SportCompetitionsState } from './SportCompetitionsState';
import { CompetitionId } from 'src_common/common/websocket2/id/WebsocketId';
import { ArrowUpIcon } from 'src/assets/icons/ArrowUpIcon';
import { CompetitionSourceType, getCompetitionSource } from './competitionSource';

const SOURCE_STYLES: Record<CompetitionSourceType, { label: string; color: string; textColor: string }> = {
    spin: { label: 'SPIN', color: '#3d86c6', textColor: '#555' },
    lsports: { label: 'LSPORTS', color: '#43a047', textColor: '#555' },
    heron: { label: 'HERON', color: '#8e5cc4', textColor: '#555' },
    'stratos-feed': { label: 'STRATOS', color: '#8796a3', textColor: '#555' },
    'stratos-manual': { label: 'STRATOS MANUAL', color: '#e08a00', textColor: '#8a4b00' },
};

const SourceBadge = styled('span', { label: 'SourceBadge' })<{ source: CompetitionSourceType }>`
    /* floated so the badge sits on the row's first line without changing the inline layout of other items;
       margin-right leaves room for the absolutely positioned 16px drag icon (VerticalMoveIconWrapper) */
    float: right;
    margin-right: 24px;
    padding: 0 5px;
    white-space: nowrap;
    background-color: #fff;
    border: 1px solid #d0d0d0;
    border-left: 3px solid ${(props): string => SOURCE_STYLES[props.source].color};
    border-radius: 2px;
    font-size: 10px;
    color: ${(props): string => SOURCE_STYLES[props.source].textColor};
`;
const Saving = styled('span', { label: 'Saving' })`
    margin-left: 10px;
    color: red;
`;
const MoveToTheTopIcon = styled(ArrowUpIcon, { label: 'MoveToTheTopIcon' })`
    fill: #000;
    width: 8px;
    height: 8px;
`;
const MoveToTheTopButton = styled('span', { label: 'MoveToTheTopButton' })`
    margin-right: 10px;
    border: 1px solid #000;
    padding: 0px 3px 0px 3px;
    border-radius: 2px;
    cursor: pointer;
    &:hover,
    &:focus {
        background-color: #ccc;
    }
`;

type SportCompetitionsItemPropsType = {
    competitionId: CompetitionId;
    competition: CompetitionType;
    isDragged: boolean;
    state: SportCompetitionsState;
};

export const SportCompetitionsItem = observer('SportCompetitionsItem', (props: SportCompetitionsItemPropsType) => {
    const { competitionId, state } = props;
    const movedId = state.movedId;
    const saving = movedId === competitionId ? <Saving>Saving ...</Saving> : null;
    const isFirstCompetition = state.getCompetitionToMoveIndex(competitionId) === 0;
    const { id, idV2, name } = props.competition;
    const source = getCompetitionSource(idV2);
    return (
        <ItemWrapper>
            {source === null ? null : (
                <SourceBadge
                    source={source}
                    title={`id: ${id}\nidv2: ${idV2}`}
                    data-test='competition-source'
                >
                    {SOURCE_STYLES[source].label}
                </SourceBadge>
            )}
            {isFirstCompetition ? null : (
                <MoveToTheTopButton onClick={(e) => state.onMoveCompetitionToTheTopHandler(e, competitionId)}>
                    <MoveToTheTopIcon />
                </MoveToTheTopButton>
            )}

            <span>{name}</span>
            {saving}
            <ItemButton
                isDragged={props.isDragged}
                data-movable-handle
                tabIndex={-1}
                data-test='item-drag-button'
            >
                <VerticalMoveIconWrapper />
            </ItemButton>
        </ItemWrapper>
    );
});
